import type {
  MedicalRecordMobileCapabilities,
  MedicalRecordMobileConfig,
} from "./medical-record-mobile.types";

export function resolveMedicalRecordMobileConfig({
  mode,
  canEdit,
}: MedicalRecordMobileCapabilities): MedicalRecordMobileConfig {
  if (mode === "create") {
    return {
      showContext: true,
      showTranscription: true,
      showOverflow: false,
      primaryAction: "save-attendance",
      secondaryAction: "cancel",
    };
  }

  if (mode === "edit") {
    return {
      showContext: true,
      showTranscription: true,
      showOverflow: false,
      primaryAction: "save-changes",
      secondaryAction: "cancel",
    };
  }

  return {
    showContext: true,
    showTranscription: false,
    showOverflow: true,
    primaryAction: canEdit ? "edit" : null,
    secondaryAction: "back",
  };
}
